import produce from 'immer';
import { ReadAdvancedSearchResultsApiArg } from 'lib-shared-types-api';
import moment from 'moment-timezone';

import { isDateCondition } from 'app/views/layout/views/search/utils/date/isDateCondition';

export function transformReadAdvancedSearchResultsArg({
  params,
}: ReadAdvancedSearchResultsApiArg): ReadAdvancedSearchResultsApiArg {
  return {
    params: produce(params, (draftParams) => {
      if (draftParams.filters) {
        draftParams.filters.conditions.forEach((condition) => {
          if (isDateCondition(condition)) {
            condition.meta = { timezone: moment.tz.guess() };
          }
        });
      }

      // Pagination is 1-based in the frontend and 0-based in the backend
      draftParams.page = (draftParams.page ?? 1) - 1;
    }),
  };
}
